import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import SortIcon from "@material-ui/icons/Sort";
import IconButton from "@material-ui/core/IconButton";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    width: "100%"
  },
  container: {
    maxHeight: 440
  }
});

const TableReturns = props => {
  const classes = useStyles();
  const {
    searchOrders,
    requestSort,
    getClassNamesFor,
    motivo,
    setMotivo,
    estado,
    setEstado,
    moduleType
  } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ minWidth: "100px" }}>
                Id 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("id")}
                  className={getClassNamesFor("id")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                SKU 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("id_insumo_medicamento.sku")}
                  className={getClassNamesFor("id_insumo_medicamento.sku")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                Paciente 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("id_paciente.nombre")}
                  className={getClassNamesFor("id_paciente.nombre")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                Tipo producto 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("id_insumo_medicamento.tipo_producto")}
                  className={getClassNamesFor("id_insumo_medicamento.tipo_producto")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                Cantidad 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("cantidad_productos")}
                  className={getClassNamesFor("cantidad_productos")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                Motivo 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("motivo")}
                  className={getClassNamesFor("motivo")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                Fecha 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("fecha_tentativa_llegada")}
                  className={getClassNamesFor("fecha_tentativa_llegada")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center" style={{ minWidth: "200px" }}>
                Estado 
                <IconButton
                  color="primary"
                  aria-label="sort"
                  onClick={() => requestSort("estado_bodega")}
                  className={getClassNamesFor("estado_bodega")}
                >
                  <SortIcon />
                </IconButton>
              </TableCell>
              <TableCell align="center">Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {searchOrders
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => (
                <TableRow key={row.id} align="center">
                  <TableCell align="center">{row.id}</TableCell>
                  <TableCell align="center">
                    {row.producto_bodega.sku_bodega ? row.producto_bodega.sku_bodega : row.producto.SKU}
                  </TableCell>
                  <TableCell align="center">{row.paciente_nombre}</TableCell>
                  <TableCell align="center">{row.id_solicitud_ingreso.tipo_producto}</TableCell>
                  <TableCell align="center">{row.id_solicitud_ingreso.cantidad_productos}</TableCell>
                  <TableCell align="center">{row.id_equipo_solcitud?.motivo}</TableCell>
                  <TableCell align="center">{row.id_solicitud_ingreso.fecha_tentativa_llegada}</TableCell>
                  <TableCell align="center">{row.id_solicitud_ingreso.estado_bodega}</TableCell>
                  <TableCell align="center">
                    <Link
                      // to={`/admin/warehouse/reception/addfile/${moduleType}/${row.id_solicitud_ingreso.id}`}
                      to={`/admin/warehouse/entry/addfile/${moduleType}/${row.id_solicitud_ingreso.id}`}
                    >
                      <Button
                        style={{ textTransform: "none" }}
                        variant="contained"
                        color="primary"
                      >
                        Detalle
                      </Button>
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={searchOrders.length}
        rowsPerPage={rowsPerPage}
        page={page}
        SelectProps={{
          inputProps: { "aria-label": "Filas por página" },
          native: false
        }}
        labelRowsPerPage={"Filas por página"}
        nextIconButtonText={"Siguiente"}
        backIconButtonText={"Atrás"}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to === -1 ? count : to} de ${
            count !== -1 ? count : `más que ${to}`
          }`
        }
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default TableReturns;

TableReturns.propTypes = {
  searchOrders: PropTypes.array,
  requestSort: PropTypes.func,
  getClassNamesFor: PropTypes.func,
  motivo: PropTypes.string,
  setMotivo: PropTypes.func,
  estado: PropTypes.string,
  setEstado: PropTypes.func,
  moduleType: PropTypes.string
};
